import * as React from 'react'
import { FC, useMemo } from 'react'
import { ServiceLocationCardProps } from './typings'
import { SmallLocationCard } from '@user/components/Location'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'
import { locationToLocationDTO } from '@user/store/entityLocations'

export const ServiceLocationCard: FC<ServiceLocationCardProps> = (props) => {
  const { serviceLocation, styles } = props

  const [expanded, toggleExpanded] = useToggleBoolean()

  const location = useMemo(
    () => locationToLocationDTO(serviceLocation),
    [serviceLocation],
  )

  return (
    <SmallLocationCard
      {...props}
      location={location}
      open={expanded}
      toggleOpen={toggleExpanded}
      isEditable={false}
      hidePopover
      className={styles.serviceCard}
    />
  )
}
ServiceLocationCard.displayName = 'ServiceLocationCard'
